(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const matching = el => [...document.querySelectorAll('[data-purchase]')].filter(p => p.dataset.productId === el.dataset.productId);
  function renderBundles(target, option, qty) {
    target.querySelectorAll('[data-bundle]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.bundle === qty)));
    target.querySelectorAll('[data-fill]').forEach(el => {
      const value = option.getAttribute('data-' + el.dataset.fill) || '';
      el.textContent = value ? (el.dataset.prefix || '') + value + (el.dataset.suffix || '') : '';
      el.hidden = !value;
    });
  }
  function sync(source) {
    const select = source.querySelector('[data-variant]');
    const option = select?.selectedOptions[0];
    const quantity = source.querySelector('[data-quantity]');
    if (!option || !quantity) return;
    const qty = quantity.value || '1';
    const total = option.getAttribute('data-total-' + qty) || option.dataset.price;
    for (const target of matching(source)) {
      target.querySelector('[data-variant]').value = option.value;
      target.querySelector('[data-quantity]').value = qty;
      const price = target.querySelector('.ml-price[data-price]');
      if (price) price.textContent = total;
      renderBundles(target, option, qty);
      const button = target.querySelector('[data-add]');
      button.disabled = button.dataset.ready !== 'true' || option.dataset.available !== 'true';
      if (button.dataset.ready === 'true') button.textContent = option.dataset.available === 'true' ? button.dataset.label : source.dataset.unavailable;
    }
    document.querySelectorAll('[data-sticky-price]').forEach(el => el.textContent = total);
    const sticky = document.querySelector('[data-sticky-add]');
    if (sticky && source.querySelector('[data-add]').dataset.ready === 'true') {
      sticky.disabled = option.dataset.available !== 'true';
      sticky.textContent = option.dataset.available === 'true' ? source.querySelector('[data-add]').dataset.label : source.dataset.unavailable;
    }
    if (option.dataset.image) setImage(option.dataset.image, option.textContent);
  }
  function setImage(url, alt) {
    const holder = document.querySelector('[data-main-photo]');
    if (!holder) return;
    const img = document.createElement('img');
    img.src = url; img.alt = alt || ''; img.width = 900; img.height = 900;
    holder.replaceChildren(img);
  }
  document.addEventListener('click', event => {
    const photo = event.target.closest('[data-gallery-image]');
    if (photo) setImage(photo.dataset.galleryImage, photo.dataset.galleryAlt);
    const bundle = event.target.closest('[data-bundle]');
    if (bundle) {
      const purchase = bundle.closest('[data-purchase]');
      const quantity = purchase?.querySelector('[data-quantity]');
      if (quantity) {quantity.value = bundle.dataset.bundle; sync(purchase);}
    }
    const sticky = event.target.closest('[data-sticky-add]');
    if (sticky) {
      const offer = document.querySelector('#offer');
      const form = offer?.querySelector('.ml-product-form');
      const submit = form?.querySelector('[data-add]');
      if (submit && !submit.disabled) {form.requestSubmit(submit); return;}
      const control = offer?.querySelector('[data-variant]:not(.ml-sr-only)') || offer?.querySelector('[data-bundle]');
      (control || offer)?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
      if (control) control.focus({preventScroll:true});
    }
  });
  document.addEventListener('change', event => {
    const purchase = event.target.closest('[data-purchase]');
    if (purchase && event.target.matches('[data-variant]')) sync(purchase);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.ml-product-form');
    if (!form) return;
    const button = form.querySelector('[data-add]');
    if (button.disabled) {event.preventDefault(); return;}
    event.preventDefault();
    const groups = matching(form.closest('[data-purchase]'));
    groups.forEach(p => p.querySelector('[data-add]').disabled = true);
    const error = form.closest('[data-purchase]').querySelector('[data-error]');
    error.hidden = true;
    try {
      const response = await fetch(root() + 'cart/add.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || form.closest('[data-purchase]').dataset.errorMessage);
      location.assign(root() + 'cart');
    } catch (failure) {
      error.textContent = failure.message; error.hidden = false; sync(form.closest('[data-purchase]'));
    }
  });
  function stickyVisibility() {
    const sticky = document.querySelector('[data-sticky]');
    if (!sticky) return;
    const hero = document.querySelector('#offer [data-add]');
    if (hero) new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting;}, {threshold:0}).observe(hero);
  }
  stickyVisibility();
  document.addEventListener('shopify:section:load', stickyVisibility);
})();
